module.exports = __webpack_public_path__ + "img/gender.cbbabec6.svg";